import { Routes } from '@angular/router';

export enum IntegrationTelegramRoutes {
  USERS = 'users',
  CHATS = 'chats',
  AUTHENTICATION = 'authentication',
}

export const INTEGRATIONS_TELEGRAM_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./integrations-telegram.component').then(
        (m) => m.IntegrationsTelegramComponent
      ),
    children: [
      {
        path: '',
        redirectTo: IntegrationTelegramRoutes.USERS,
        pathMatch: 'full',
      },
      {
        path: IntegrationTelegramRoutes.USERS,
        loadComponent: () =>
          import(
            './pages/telegram-integration-users/telegram-integration-users.component'
          ).then((m) => m.TelegramIntegrationUsersComponent),
      },
      {
        path: IntegrationTelegramRoutes.CHATS,
        loadComponent: () =>
          import(
            './pages/telegram-integration-chats/telegram-integration-chats.component'
          ).then((m) => m.TelegramIntegrationChatsComponent),
      },
      {
        path: IntegrationTelegramRoutes.AUTHENTICATION,
        loadComponent: () =>
          import(
            './pages/telegram-integration-authentication/telegram-integration-authentication.component'
          ).then((m) => m.TelegramIntegrationAuthenticationComponent),
      },
    ],
  },
];
